export default function Header() {
    return (<>
        <div className="flex p-5">
            <div className="flex-grow">
                <h3 className="font-bold text-2xl">سلام حسن،</h3>
                <p className="text-secondary-500 text-sm">میتونی هر فروشگاهی خواستی پیدا کنی</p>
            </div>
            <div className="rounded-full w-14 h-14 bg-white border-gray-400 text-gray-400 border-2 inline-block">
                <p className="text-center w-14 h-14 table-cell align-middle">
                    <i className="fa-regular fa-bell align-middle"></i>
                </p>
            </div>
        </div>
    </>)
}